import { CATEGORY_TO_SCHEMA } from './seoSchemaMap.js';

const SCHEMA_URL_PREFIX = 'https://schema.org/';

export const normalizeCategoryId = parentId => {
  if (typeof parentId !== 'string') return null;
  const trimmed = parentId.trim();
  if (!trimmed) return null;
  return trimmed.startsWith('mp:') ? trimmed.slice(3) : trimmed;
};

export const toSchemaUrl = type => `${SCHEMA_URL_PREFIX}${type}`;

export const resolveSchemaTypes = storeCategories => {
  const categories = Array.isArray(storeCategories) ? storeCategories : [];
  const hasAnyCategory = categories.length > 0;

  const normalizedIds = categories
    .map(cat => normalizeCategoryId(cat?.parentId))
    .filter(Boolean);

  if (normalizedIds.length === 0) {
    return {
      primary: 'LocalBusiness',
      additional: hasAnyCategory ? [toSchemaUrl('RentalService')] : [],
    };
  }

  const mappedEntries = normalizedIds
    .map(id => {
      const entry = CATEGORY_TO_SCHEMA[id];
      if (!entry && typeof console !== 'undefined' && typeof console.warn === 'function') {
        // console.warn(`[SEO] Unmapped store category parentId: ${id}`);
      }
      return entry;
    })
    .filter(Boolean);

  if (mappedEntries.length === 0) {
    return {
      primary: 'LocalBusiness',
      additional: [toSchemaUrl('RentalService')],
    };
  }

  const primary = mappedEntries[0].primary;
  const additionalSet = new Set();

  mappedEntries.forEach(entry => {
    additionalSet.add(toSchemaUrl(entry.primary));
    const extraTypes = Array.isArray(entry.additional) ? entry.additional : [];
    extraTypes.forEach(type => additionalSet.add(toSchemaUrl(type)));
  });

  additionalSet.add(toSchemaUrl('RentalService'));

  return {
    primary,
    additional: Array.from(additionalSet),
  };
};
